export const RELATIVE_DAY = {
  today: 'Today',
  yesterday: 'Yesterday',
  daysAgo: (days: number) => `${days} days ago`,
} as const;

export const ELAPSED = {
  justNow: 'just now',
  minutes: (minutes: number) => `${minutes} min ago`,
  hours: (hours: number, minutes: number) =>
    minutes ? `${hours} h ${minutes} min ago` : `${hours} h ago`,
} as const;

export const ANY_LABEL = 'Any';
export const NO_VALUE = '-';

export const moreActionsLabel = (name: string) => `More actions for “${name}”`;

export const UNKNOWN_ERROR = 'Something went wrong - please try again.';

export const HTTP_ERROR_STATUSES = [401, 403, 404, 429, 500, 502, 503, 504] as const;
export type HttpErrorStatus = (typeof HTTP_ERROR_STATUSES)[number];

export const STATUS_ERROR: Readonly<Record<HttpErrorStatus, string>> = {
  401: 'Please sign in again.',
  403: 'You don’t have access to discovery for this campaign.',
  404: 'That isn’t there any more - it may have been deleted.',
  429: 'Too many requests - wait a moment and try again.',
  500: 'Creator discovery hit an error - please try again.',
  502: 'Creator discovery is unavailable right now - please try again.',
  503: 'Creator discovery is unavailable right now - please try again.',
  504: 'Creator discovery took too long to answer - please try again.',
};
